import React from 'react';
import { Outlet } from 'react-router-dom';
import './Rogue.css';

const Rogue = () => {  

  return (
    <div className='rogue'>
      <div className='rogueOutlet'>
        <Outlet/>
      </div>
    </div>
  );
};

export default Rogue;